export default {
  name: 'Fade',
  functional: true,
  render(h, context) {
    return h('transition-group', { props: { name: 'fade', mode: 'out-in' } }, context.children);
  },
};
